import {Component, ElementRef, Input, OnInit} from '@angular/core';
import {MessageService} from '../../messages/message.service';
import {IConfigurationCaller} from '../../Configuration/iconfiguration-caller';
import {WidgetService} from '../widget.service';
import {DoraProperty, DoraPropertyArray} from '../../Decorators/Decorator';
import {PublisherService} from '../../pusblisher/publisher.service';
import {ConfigurationService} from '../../Configuration/configuration-service';
import {ComponentType} from '../../Configuration/component-type.enum';
import {DataType, IPublisher} from '../../pusblisher/ipublisher';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {TranslateService} from '@ngx-translate/core';
import {PublisherParameter} from './data/publisher-parameter';
import {TranslationService} from '../../TranslationMarkers/translation.service';

declare function DoraGetLocale(): string;

@Component({
  selector: 'dora-widget-base',
  template: ''
})
export class WidgetBaseComponent implements OnInit, IConfigurationCaller {

  // todo TEST
  // @DoraPropertyArray (DataGrid)
  // mioParametroArray: DataGrid[] = null;
  //
  // @DoraProperty
  // testOggetto: DataGrid = new DataGrid();

  @DoraProperty
  protected progressive = '1';
  @DoraProperty
  protected EventChannel = '1';
  @DoraProperty
  protected publischerNumber = 0;

  @DoraPropertyArray (PublisherParameter)
  protected publisherParameters: PublisherParameter[] = [];

  // tslint:disable-next-line:variable-name
  private _widgetType: string;
  // tslint:disable-next-line:variable-name
  private _widgetName: string;

  protected locale: string;

  constructor(
      protected elementRef: ElementRef,
      protected messageService: MessageService,
      protected configurationService: ConfigurationService,
      protected publisher: PublisherService,
      protected widgetService: WidgetService,
      protected http: HttpClient,
      protected translationService: TranslationService
  ) {
    // set locale
    this.locale = DoraGetLocale();
  }

  ngOnInit() {
    this._widgetType = this.constructor.name;

    // todo test
    // let res = Reflect.getMetadata('design:type', this, 'mioParametroArray');
    // if (res !== null && res.name !== 'Array') {
    //   // tslint:disable-next-line:new-parens
    //   this.mioParametro =  new res;
    //   console.log('vuoto');
    // }
    // res = Reflect.getMetadata('DoraPropertyArray', this, 'mioParametroArray');
    // if (res !== null && res.name !== 'Array') {
    //   this.mioParametroArray = new Array();
    //
    //   // tslint:disable-next-line:new-parens
    //   this.mioParametroArray.push(new res);
    // }


    // inject parameter
    this.configurationService.injectParametersToComponent(this, this.elementRef.nativeElement.parentElement.attributes);
  }
  onParameterInjectedFinished(): void {
    this._widgetName = this._widgetType + this.progressive;
    this.widgetService.addWidget(this);

    // set id to parent element
    this.elementRef.nativeElement.parentElement.setAttribute('id', this._widgetName);
    console.log('Init: Base. Widget: ' + this._widgetName);
  }

  onRefresh(): void {
    this._widgetName = this._widgetType + this.progressive;
  }
  get widgetType(): string {
    return this._widgetType;
  }

  get widgetName(): string {
    return this._widgetName;
  }

  // IConfigurationCaller methods

  get CallerSubType(): string {
    return this._widgetType;
  }

  get CallerName(): string {
    return this.widgetName;
  }
  get CallerProgressive(): string {
    return this.progressive;
  }

  get CallerType(): ComponentType {
    return ComponentType.Widgets;
  }

  setCallerProgressive(progressive: string): void {
    this.progressive = progressive;
    this._widgetName = this._widgetType + this.progressive;
  }


  // Publisher operations

  // tslint:disable-next-line:ban-types max-line-length
  public read(subscribeObjInfo: string[], dataType: DataType, publisherParameters: Map<string, string> = null, callerData: any = null): Observable<Object> {

    // get publisher
    const publisher: IPublisher = this.publisher.getPublisher(this.publischerNumber);

    // get html attributes
    const attributesHtml: NamedNodeMap = this.elementRef.nativeElement.parentElement.attributes;

    // get rewritable parameter
    const rewritableParameters: Map<string, string> = publisher.getRewritableParameterMap();

    // get all key
    const keys: string[] = [];
    rewritableParameters.forEach((value: string, key: string) => {
      keys.push(key);
    });

    keys.forEach( key => {
      const attribute: Attr = attributesHtml.getNamedItem(key.toLowerCase());
      if (attribute !== null) {
        rewritableParameters.set(key, attribute.value);
      }
    });

    // add parameters from widget
    if (publisherParameters !== null) {
      // specific parameters passed by caller
      publisherParameters.forEach((value: string, key: string) => {
        rewritableParameters.set(key, value);
      });
    } else {
      // parameter from widget
      this.publisherParameters.forEach((value: PublisherParameter) => {
        rewritableParameters.set(value.name, value.value);
      });
    }

    return publisher.read(rewritableParameters, subscribeObjInfo, dataType, callerData);
  }
  /**
   * Read publisher parameters in Map format
   */
  protected getPublisherParameters(publisherParameters: PublisherParameter[]): Map<string, string> {
    const result: Map<string, string> = new Map<string, string>();

    publisherParameters.forEach( value => {
      result.set(value.name, value.value);
    });

    return result;
  }

}
